<mat-card>
  <div class="loading-overlay" *ngIf="isLoading">
    <div class="spinner-container">
      <mat-spinner diameter="50"></mat-spinner>
      <p>Loading providers...</p>
    </div>
  </div>
  
  <mat-card-content>
    <h1>Provider Details</h1>
    <div id="top">
      <ul>
        <li>Providers are mapped to the registry for calculation and results display on the Dashboard.</li>
        <li>Click UPLOAD PROVIDERS to upload a set of provider data. NPIs may not be duplicated within the file.</li>
        <li>User accounts can be created from the grid. User specific fields will be required.</li>
        <li>Newly created users should follow the reset password link to finalize user activation.</li>
      </ul>
      <button 
        mat-fab 
        extended 
        class="warn" 
        id="createProviderButton" 
        (click)="openCreateProviderModal($event)">
        <mat-icon>person_add</mat-icon>
        CREATE PROVIDER
      </button> 
      <button 
        mat-fab 
        extended 
        class="warn" 
        id="uploadProvidersButton" 
        (click)="openUploadProvidersModal()">
        <mat-icon>upload_file</mat-icon>
        UPLOAD PROVIDERS
      </button>
    </div>
    
    <div class="content">
      <ag-grid-angular
        style="width: 100%; height: 450px"
        [theme]="theme"
        [rowData]="dataSource$ | async"
        [columnDefs]="colDefs"
        [suppressCellFocus]="true"
        [defaultColDef]="defaultColDef"
        (gridReady)="onGridReady($event)"
        [gridOptions]="gridOptions"
        [components]="frameWorkComponents"
        (cellClicked)="onCellClicked($event)"
      />
    </div>
    <div class="grid-actions">
      <mat-checkbox 
        [(ngModel)]="showInactive"
        (change)="onShowInactiveChange()"
        class="show-inactive-checkbox">
        Show Inactive Providers
      </mat-checkbox>
      <button mat-button (click)="exportCsv()">
        <mat-icon>file_download</mat-icon>
        Export to CSV
      </button>
    </div>
  </mat-card-content>
</mat-card>